export default "__VITE_PUBLIC_ASSET__45dbd64f__"